import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TABS } from '@symphony-solo/shared/utils/src';
import { tap } from 'rxjs/operators';
import { selectCustomerGroupAction } from './customer-groups.actions';

@Injectable()
export class CustomerGroupsEffects {
  constructor(private actions$: Actions, private navController: NavController) {}

  protected selectCustomerGroup$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(selectCustomerGroupAction),
        tap(() => {
          this.navController.navigateRoot(TABS);
        })
      );
    },
    { dispatch: false }
  );
}
